import { DatePipe } from "@angular/common";
import moment, { DurationInputArg2 } from "moment";

export default class DateTimeHelper {

  static minutesToTimeString(minutes: number): string {
    const hrs = Math.floor(minutes / 60);
    const mins = minutes % 60;
    const paddedHrs = hrs.toString().padStart(2, '0');
    const paddedMins = mins.toString().padStart(2, '0');
    return `${paddedHrs}:${paddedMins}`;
  }

  static formatTimespan(timespan: string): string {
    const time = moment(timespan, "HH:mm:ss");
    const hours = time.hours().toString().padStart(2, '0');
    const minutes = time.minutes().toString().padStart(2, '0');

    return `${hours}:${minutes}`;
  }
  static getAge(dateOfBirth: Date): number {
    const diff = moment().diff(moment(dateOfBirth), 'years');
    return diff;
  }
  static timespanToDate(timespan: string): Date | null {
    if (!timespan) {
      return null;
    }

    const parts = timespan.split(':');
    let seconds = 0;

    const hours = Number(parts[0]);
    const minutes = Number(parts[1]);
    if (parts.length == 3) {
      seconds = Number(parts[2]);
    }


    const date = new Date(0); // Unix epoch
    date.setHours(hours, minutes, seconds, 0);

    return date;
  }

  static roundUp(time: moment.Moment, roundBy: DurationInputArg2): moment.Moment | null {
    if (!time) {
      return null;
    }

    return time.add(1, roundBy).startOf(roundBy);
  }

  static getTotalMinutes(timeSpan: string): number {
    return moment.duration(timeSpan).asMinutes();
  }

  static getDateDifference(startDate: Date, endDate: Date) : moment.Duration | null {
    if (!startDate || !endDate) {
      return null;
    }

    const time1 = moment(startDate);
    const time2 = moment(endDate);
    const duration = moment.duration(time2.diff(time1));

    return duration;
  }

  static getTimeSpanDifference(startDate: string | null, endDate: string | null): moment.Duration | null {
    if (!startDate || !endDate) {
      return null;
    }

    const time1 = moment(startDate, "HH:mm:ss");
    const time2 = moment(endDate, "HH:mm:ss");
    const duration = moment.duration(time2.diff(time1));


    return duration;
  }

  static addTimeToDate(date: Date | null, time: string | null): Date | null {
    if (date) {
      const newDate: Date = new Date(date);

      if (time) {
        const parts = time.split(':');
        const hours = Number(parts[0]);
        const minutes = Number(parts[1]);

        newDate.setHours(hours, minutes, 0, 0);
      }

      return newDate;
    }

    return null;
  }

  static getTimeFromDateOrMoment(datePipe: DatePipe, dateOrMoment: Date | moment.Moment): string | null {

    if(moment.isMoment(dateOrMoment)) {
      return this.getTimeFromDate(datePipe, (dateOrMoment as moment.Moment).toDate());
    }

    // Return null if Date is invalid. No good way to check this? 
    if((dateOrMoment as Date).toString() == 'Invalid Date') {
      return null;
    }

    return this.getTimeFromDate(datePipe, new Date(dateOrMoment));
  }

  static getTimeFromDate(datePipe: DatePipe, date: Date | null): string | null {
    return datePipe.transform(date, 'HH:mm');
  }

  static getDateOnly(date: Date): Date {
    return new Date(date.toDateString());
  }

  static getlocalDateOnlyFromUTC(date: Date): Date {
    const result = new Date(date);
    result.setHours(0);
    result.setMinutes(0);

    return result;
  }

  static addYears(date: Date, years: number): Date {
    const result = new Date(date);
    result.setFullYear(date.getFullYear() + years);

    return result
  }

  static addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);

    return result;
  }

  static addMonths(date: Date, months: number): Date {
    const result = new Date(date);
    result.setMonth(date.getMonth() + months);

    return result;
  }

  static addHours(date: Date, hours: number): Date {
    const result = new Date(date);
    result.setHours(date.getHours() + hours);

    return result;
  }

  static addMinutes(date: Date, minutes: number): Date {
    const result = new Date(date);
    result.setMinutes(date.getMinutes() + minutes);

    return result;
  }

  static getFirstDayOfMonthDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }

  static getLastDayOfMonthDate(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth() + 1, 0);
  }

  static getDateFromMomentOrDate(date: any): Date {
    if (date instanceof moment) {
      return moment(date).toDate();
    }

    // Could also be a string
    return new Date(date);
  }

  static getTimeZone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  static getStartOfDay(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  static getEndOfDay(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
  }

  static getStartOfDayOrDefault(date: Date | null): Date | null {
    if (date) {
      return DateTimeHelper.getStartOfDay(date);
    }

    return null;
  }

  static getDateOrDefault(value: Date | string | null): Date | null {
    if (!value) {
      return null;
    }

    if (value instanceof moment) {
      return moment(value).toDate();
    }

    return new Date(value);
  }

  public static isDateString(value) {
    if (value === null || value === undefined || typeof value !== 'string') {
      return false;
    }

    const regex = /^\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d(?:\.\d+)?Z?/;

    return regex.test(value);
  }
}
